
import { onMounted, reactive, computed, ref, onUnmounted, nextTick } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { callApi, callPostApi, sendMessageToFlutter, sendUrlToAndroid } from '@/api/api'
import Spinner from '@/components/transitions/Spinner.vue'
import MaskLayer from '@/components/share/MaskLayer.vue'
import moment from 'moment'
import Fade from '@/components/transitions/Fade.vue'
import defaultImg from '@/assets/images/mobile/swipper-default-img.png'
import defaultFeatureIcon from '@/assets/images/mobile/feature-icon-field.png'
import nextIcon from '@/assets/images/mobile/next-feature-icon.png'
import loadingFeatureIcon from '@/assets/images/mobile/loading-feature-icon.png'
import feildMsgIcon from '@/assets/images/mobile/icon_loading-feild-18.png'
import loadingFeatureCatiguryIcon from '@/assets/images/mobile/feature-catigury-loading.png'
import { isAndroid, isIOS, toHttpsAbsolute } from '@/utils/utils'
import NoteDialog from '@/components/custom_functions/NoteDialog.vue'
export default {
    name: "CustomFunctions",
    components: {
        Spinner,
        MaskLayer,
        Fade,
        NoteDialog
    },
    setup() {
        let intervalId: ReturnType<typeof setInterval> | null = null;
        let intervalId2: ReturnType<typeof setInterval> | null = null;
        const store = useStore()
        const local = computed(() => store.state.translation.locale)
        const router = useRouter()
        const route = useRoute()
        const contentMessages = ref<HTMLElement | null>(null)
        const catBar = ref<HTMLElement | null>(null)
        const catContainer = ref<HTMLElement | null>(null)
        const data = reactive({
            encryptedToken: decodeURIComponent(route.query.id as any ?? ' ').replace(/\s/g, '+').replace(/%2B/g, '+'),
        })
        const state = reactive({
            showLoading: false,
            loadingFeatures: false,
            catigurySelected: false,
            showNote: false
        })
        const images = computed(() => {
            if (store.state.customFeatures.images === null) {
                return [{
                    _id: null,
                    name: "",
                    image_link: loadingFeatureIcon,
                    url: "",
                    status: null,
                    sorting_order: 0,
                    createdAt: null,
                    id: null,
                    title: ""
                }];
            } else {
                return store.state.customFeatures.images
            }
        })
        const features = computed(() => {
            if (store.state.customFeatures.features === null) {
                return Array.from({ length: 10 }, () => ({ title: '', image_link: loadingFeatureIcon, url:'', active: false }));
            } else {
                return store.state.customFeatures.features
            }
        })
        const messages = computed(() => {
            if (store.state.customFeatures.messages === null) {
                return Array.from({ length: 2 }, () => ({ title: local.value.defaultMessage, image: loadingFeatureIcon, url:"" }));
            } else {
                return store.state.customFeatures.messages
            }
        })
        const catiguries = computed(() => {
            if (store.state.customFeatures.catiguries === null) {
                let loadingCatigories = Array.from({ length: 15 }, () => ({ title: local.value.defaultFeatureCatiguryName, image_link: loadingFeatureCatiguryIcon,url:'',load:false }))
                return {
                    'cat_local_1': loadingCatigories,
                    'cat_local_2': loadingCatigories,
                    'cat_local_3': loadingCatigories,
                    'cat_local_4': loadingCatigories,
                    'cat_local_5': loadingCatigories,
                    'cat_local_6': loadingCatigories,
                    'cat_local_7': loadingCatigories,
                }
            } else {
                return store.state.customFeatures.catiguries
            }
        })

        const keyToIndex = computed<Record<string, number>>(() => {
            const out: Record<string, number> = {}
            Object.keys(catiguries.value).forEach((k, i) => (out[k] = i))
            return out
        })

        const tabsCatiguries = computed(() => {
            return {
                'cat_local_1': local.value.cat_1,
                'cat_local_2': local.value.cat_2,
                'cat_local_3': local.value.cat_3,
                'cat_local_4': local.value.cat_4,
                'cat_local_5': local.value.cat_5,
                'cat_local_6': local.value.cat_6,
                'cat_local_7': local.value.cat_7
            }
        })

        const currentCatigury = computed(() => {
            return state.catigurySelected ? store.state.customFeatures.currentCatigury : Object.keys(catiguries.value)[0]
        })


        // Slides config
        // -------------------------------------------------------------------------------------------
        const currentIndex = ref(0);
        const startX = ref(0)
        const isDragging = ref(false)
        const dragDistance = ref(0)
        const isClick = ref(true)
        
        const touchStartX = ref(0);
        const touchEndX = ref(0);
        const touchStartFeatures = ref(0);
        const touchEndFeatures = ref(0);
        const currentFeaturesSlide = ref(0);
        const featuresPerSlide = ref(10);
        const featuresAreVisible = ref(false)
        const featuresAreVisible1 = ref(false)
        const totalFeaturesSlides = computed(() => Math.ceil(features.value.length / featuresPerSlide.value))
        const currentSlideFeatures = computed(() => {
            let start = currentFeaturesSlide.value * featuresPerSlide.value
            let end = start + featuresPerSlide.value
            return features.value.slice(start, end)
        })

        const getAgentType = computed(()=> {
            if(isAndroid()) return 1;
            else if(isIOS()) return 2;
            else return 0
        })

        const featureLoadingIcon_ = computed(() => {
            return loadingFeatureCatiguryIcon
        })

        onMounted(() => {
            featuresAreVisible.value = true
            featuresAreVisible1.value = true
            //  Open dialog when loading page first time
            if(store.state.customFeatures.disclaimerFlag === true) {
                openComponent('showNote')
                store.dispatch('customFeatures/setDisclaimerFlag', false)
            }
        })
        // -------------------------------------------------------------------------------------------

        onUnmounted(() => {
            if (intervalId !== null)
                clearInterval(intervalId);
            if (intervalId2 !== null)
                clearInterval(intervalId2);
        });
        onMounted(async () => {
            intervalId = setInterval(() => {
                if (contentMessages.value) {
                    const element = contentMessages.value
                    const isAtEnd = element.scrollTop + element.clientHeight >= element.scrollHeight - 1
                    if (isAtEnd) {
                        element.scrollTo({ top: 0, behavior: 'smooth' })
                    } else {
                        element.scrollTo({
                            top: element.scrollTop + 74,
                            behavior: 'smooth'
                        })
                    }
                }
            }, 5000);

            intervalId2 = setInterval(() => {
                nextSlide();
            }, 5000);

            await store.dispatch(`translation/getLangs`, { userLang: route.query.lang ?? 'cn' })
            state.loadingFeatures = true
                const res = await callApi('/external-links', 'GET', data.encryptedToken as any, route.query.lang + '' || 'cn')
                .finally(() => {state.loadingFeatures = false})
                if (res.isSuccess) {
                    // setFeaturesArr ---------------------------------------------------------
                    let res1 = res.data.filter((item)=> item.section_type === 1)
                    res1 = res1.map((item) => ({...item, active: true})).sort((a,b) => (a.sorting_order - b.sorting_order))
                    let len = res1.length
                    if (len < 10) {
                        res1 = [...res1, ...Array.from({ length: 10 - len }, () => ({ title: '', image_link: nextIcon, url:'', active: false }))]
                    }else {
                        res1 = res1.slice(0,10)
                    }
                    await store.dispatch('customFeatures/setFeaturesArr', res1)
                    
                    // setImagesArr ------------------------------------------------------------
                    let res2 = res.data.filter((item)=> item.section_type === 0).sort((a,b) => (a.sorting_order - b.sorting_order)) 
                    if(!res2.length) res2 = ['']
                    await store.dispatch('customFeatures/setImagesArr', res2)

                    // setMessagesArr -----------------------------------------------------------
                    let res3 = res.news || []
                    if(!res3.length) res3 = Array.from({ length: 2 }, () => ({ title:local.value.defaultMessage, image:"", url:"" }))
                    await store.dispatch('customFeatures/setMessagesArr', res3)

                    //  setCatiguries ----------------------------------------------------------
                    let defaultCatigories = Array.from({ length: 15 }, () => ({ title: '我是个功能', image_link: '', url:'',load:true }))
                    let resDefault = {
                    'Hot' : defaultCatigories,
                    'Cat1': defaultCatigories,
                    'Cat2': defaultCatigories,
                    'Cat3': defaultCatigories,
                    'Cat4': defaultCatigories,
                    'Cat5': defaultCatigories,
                    'Cat6': defaultCatigories,
                    }
                    let res4 = res.data.filter((item) => item.section_type === 3)
                    let setCatTitlesArr = res.categoriesArr
                    setCatTitlesArr.sort((a, b) => a.sorting_order - b.sorting_order)
                    let res5 =  {}  
                    setCatTitlesArr.forEach(element=> {
                        let key = element.title
                        let value = res4.filter((item) => element.title === item.cat_title).map((element) => ({...element,load:false})).sort((a,b) => (a.sorting_order - b.sorting_order))
                        res5[key] = value
                    })
                    if(Object.keys(res5).length === 0) res5 = resDefault
                    await store.dispatch('customFeatures/setCatiguries', res5)
                    if (currentCatigury.value.includes('cat_local'))
                        await store.dispatch('customFeatures/setCurrentCatigury', Object.keys(catiguries.value)[0])
                    // --------------------------------------------------------------------------------------------
                } else {
                    await store.dispatch('customFeatures/setFeaturesArr', null)
                    await store.dispatch('customFeatures/setImagesArr', null)
                    await store.dispatch('customFeatures/setMessagesArr', null)
                    await store.dispatch('customFeatures/setCatiguries', null)

                    router.push(
                        {
                            path: '/external-links-error',
                            query: { lang: route.query.lang ?? 'cn',title: local.value.external_links_error, external_links: '1' },
                        }
                    )
                }
        });

        function toggleComponent(name: string) {
            if (name in state) {
                state[name] = !state[name]
            }
        }

        function closeTab_() {
            sendMessageToFlutter('clickBack')
        }

        const closeComponent = (name: string) => {
            if (name in state) {
                state[name] = false
            }
        }

        const openComponent = (name: string) => {
            if (name in state) {
                state[name] = true
            }
        }


        const convertDate = (date) => {
            return moment(date).format("YYYY-MM-DD HH:mm")
        }

        const selectCatigury = async (key) => {
            await store.dispatch('customFeatures/setCurrentCatigury', key)
            state.catigurySelected = true
            showFeaturesWithFade(2)
            scrollCatsBar(keyToIndex.value[key])
        }

        const scrollCatsBar = (currentIndex) => {
            let currentW = document.getElementById(`cat-${currentIndex}`)?.clientWidth || 0
            const catBar_ = catBar.value
            const catContainer_ = catContainer.value
            const len = catBar_?.children.length || 0
            const nextIndex = (currentIndex+1 < len) ? currentIndex+1 : -1
            const prevIndex = (currentIndex-1 >= 0) ? currentIndex-1 : -1
            let nextW = 0;
            let prevW = 0;

            const pr  = catContainer_?.getBoundingClientRect();
            const parentW = catContainer_?.clientWidth || 0
            const er = document.getElementById(`cat-${currentIndex}`)?.getBoundingClientRect();
            let posi =  (er?.left??0) - (pr?.left??0) ;
            const nextElement = document.getElementById(`cat-${nextIndex}`)
            nextW = nextElement?.clientWidth || 0
            const prevElement = document.getElementById(`cat-${prevIndex}`)
            prevW = prevElement?.clientWidth || 0
            if(currentIndex === 0) {
                catBar_?.scrollTo({
                            left: 0,
                            behavior: 'smooth'
                        })
            }

            else if(currentIndex === len-1) {
                catBar_?.scrollTo({
                            left: catBar_?.scrollWidth,
                            behavior: 'smooth'
                        })
            } else {
                if(posi - 16 < prevW ) {
                    catBar_?.scrollBy({
                            left:- prevW - 16 - Math.abs(posi - 16),
                            behavior: 'smooth'
                        })
                } else if (parentW - posi - currentW - 16 < nextW) {
                    catBar_?.scrollBy({
                            left: Math.abs(parentW - posi - currentW - 16) + nextW + 16,
                            behavior: 'smooth'
                        })
                }
            }
            
        }

        const onImageError = (e: Event) => {
            const target = e.target as HTMLImageElement;
            target.src = defaultImg;
        };

        const onIconFeatureError = (e: Event) => {
            const target = e.target as HTMLImageElement;
            target.src = defaultFeatureIcon;
        };

        const onIconMsgFaild = (e: Event) => {
            const target = e.target as HTMLImageElement;
            target.src = feildMsgIcon;
        }

        const onIconFeatureLoading = (id:number,catigory:string) => {
            store.dispatch('customFeatures/setLoadFeatureImg',{id:id,catigory:catigory})
        }


        // Slides config
        // -------------------------------------------------------------------------------------------
        const nextSlide = () => {
            currentIndex.value = (currentIndex.value + 1) % images.value.length;
        };
        const prevSlide = () => {
            currentIndex.value =
                (currentIndex.value - 1 + images.value.length) % images.value.length;
        };

        const startDrag = (event) => {
          startX.value = event.clientX
          isDragging.value = true
          dragDistance.value = 0
          isClick.value = true
        }

        const onDrag = (event) => {
          if (!isDragging.value) return
          dragDistance.value = event.clientX - startX.value
          if (Math.abs(dragDistance.value) > 10) {
            isClick.value = false
          }
        }

        const endDrag = () => {
            handleEnd()
        }

        const cancelDrag = () => {
            isDragging.value = false
        }

        const startTouch = (event) => {
          startX.value = event.touches[0].clientX
          isDragging.value = true
          dragDistance.value = 0
          isClick.value = true
        }

        const onTouchMove = (event) => {
          if (!isDragging.value) return
          dragDistance.value = event.touches[0].clientX - startX.value
          if (Math.abs(dragDistance.value) > 10) {
            isClick.value = false
          }
        }

        const endTouch = () => {
          handleEnd()
        }

        const handleEnd = () => {
          if (!isDragging.value) return
          isDragging.value = false
          if (!isClick.value) {
            if (dragDistance.value > 50 ) {
              prevSlide()
            } else if (dragDistance.value < -50 ) {
              nextSlide()
            }
          }
        }

        const onImageClick = () => {
            if (isClick.value) {
                // here on click image
                let img = images.value[currentIndex.value]
                if(!isAndroid() && img.url2) {
                    jumpUrl(img.url2,img.id)
                } else {
                    jumpUrl(img.url,img.id)
                }
            }
        }

        // --------------------------------------------------------------------------
        const onTouchStart = (e: TouchEvent) => {
            touchStartX.value = e.changedTouches[0].clientX;
        };

        const onTouchEnd = (e: TouchEvent) => {
            touchEndX.value = e.changedTouches[0].clientX;

            const delta = touchEndX.value - touchStartX.value;

            if (delta > 50) {
                prevSlide();
            } else if (delta < -50) {
                nextSlide();
            }
        };

        const prevFeaturesSlide = () => {
            currentFeaturesSlide.value = (currentFeaturesSlide.value - 1 + totalFeaturesSlides.value) % totalFeaturesSlides.value
        }

        const nextFeaturesSlide = () => {
            currentFeaturesSlide.value = (currentFeaturesSlide.value + 1) % totalFeaturesSlides.value
        }

        const onTouchStartFeatures = (e: TouchEvent) => {
            touchStartFeatures.value = e.changedTouches[0].clientX;
        }

        const onTouchEndFeatures = (e: TouchEvent) => {
            touchEndFeatures.value = e.changedTouches[0].clientX;

            const delta = touchEndFeatures.value - touchStartFeatures.value;

            if (delta > 50) {
                prevFeaturesSlide();
            } else if (delta < -50) {
                nextFeaturesSlide();
            }
            showFeaturesWithFade(1)
        }

        const showFeaturesWithFade = (state) => {
            if(state === 1) {
                featuresAreVisible.value = false
            } else {
                featuresAreVisible1.value = false
            }
            nextTick(() => {
                setTimeout(() => {
                    if(state === 1) featuresAreVisible.value = true
                    else featuresAreVisible1.value = true
                }, 10)
            })
        }
        const jumpUrl = async (url:string,urlId=null) => {
            if(urlId === null) {
                sendUrlToAndroid(JSON.stringify({method:'browserOpenUrl', url:url}))
            } else {
                let body = {
                id:urlId
             }
            const res = await callPostApi('/external-links/click', 'POST', JSON.stringify(body), data.encryptedToken)
            .finally(() => { 
                sendUrlToAndroid(JSON.stringify({method:'browserOpenUrl', url:url}))
            })
            if(res.isSuccess) {
                console.log('clicked success')
            } else {
                console.log('clicked faild')
            }
            }
        }
        // -------------------------------------------------------------------------------------------
        return {
            data,
            state,
            toggleComponent,
            local,
            closeComponent,
            openComponent,
            convertDate,
            images,
            features,
            currentIndex,
            onTouchStart,
            onTouchEnd,
            onImageError,
            currentFeaturesSlide,
            featuresPerSlide,
            totalFeaturesSlides,
            currentSlideFeatures,
            onTouchStartFeatures,
            onTouchEndFeatures,
            featuresAreVisible,
            featuresAreVisible1,
            onIconFeatureError,
            onIconMsgFaild,
            messages,
            catiguries,
            currentCatigury,
            selectCatigury,
            tabsCatiguries,
            contentMessages,
            jumpUrl,
            closeTab_,
            catBar,
            keyToIndex,
            catContainer,
            getAgentType,
            onIconFeatureLoading,
            featureLoadingIcon_,
            toHttpsAbsolute,
            startX,
            isDragging,
            dragDistance,
            isClick,
            startDrag,
            onDrag,
            endDrag,
            cancelDrag,
            startTouch,
            onTouchMove,
            endTouch,
            onImageClick
        }
    }
}

